export default {
  'pages.layouts.userLayout.title': '新闻联播学习',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表单提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '邮箱',
  'pages.template.form.department': '部门',
  'pages.template.form.joinDate': '入职日期',
  'pages.template.form.remarks': '备注',
  'pages.template.placeholder.name': '请输入姓名',
  'pages.template.placeholder.email': '请输入邮箱',
  'pages.template.placeholder.department': '请选择部门',
  'pages.template.placeholder.remarks': '请输入备注信息',
  'pages.template.validation.nameRequired': '请输入姓名',
  'pages.template.validation.emailRequired': '请输入邮箱',
  'pages.template.validation.emailInvalid': '邮箱格式不正确',
  'pages.template.validation.departmentRequired': '请选择部门',
  'pages.template.validation.joinDateRequired': '请选择入职日期',
  'pages.template.department.tech': '技术部',
  'pages.template.department.sales': '销售部',
  'pages.template.department.hr': '人力资源部',
  'pages.template.department.finance': '财务部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
  'pages.newsBroadcast.dashboard.title': '分析概览',
  'pages.newsBroadcast.dashboard.subtitle': '新闻联播数据总览与快捷操作',
  'pages.newsBroadcast.analysis.title': '每日联播研判',
  'pages.newsBroadcast.analysis.subtitle':
    '看懂当天新闻联播释放的政策、产业与社会信号',
  'pages.newsBroadcast.analysisTasks.title': '分析任务中心',
  'pages.newsBroadcast.analysisTasks.subtitle':
    '任务状态跟踪、失败重试与快照重建',
  'pages.newsBroadcast.search.title': '新闻搜索',
  'pages.newsBroadcast.search.subtitle': '按关键词与筛选条件检索新闻',
  'pages.newsBroadcast.keywordTrends.title': '词汇趋势',
  'pages.newsBroadcast.keywordTrends.subtitle':
    '按时间范围分析词汇热度、活跃度与趋势变化',
  'pages.newsBroadcast.dailyBrief.title': '每日简报',
  'pages.newsBroadcast.dailyBrief.subtitle': '按人群生成并分发每日简报',
  'pages.newsBroadcast.dailyBriefDetail.title': '简报详情',
  'pages.newsBroadcast.dailyBriefDetail.subtitle':
    '完整正文、核心要点、隐藏信号与行动建议',
  'pages.newsBroadcast.shareBrief.title': '每日联播简报',
  'pages.newsBroadcast.shareBrief.notFound': '简报不存在或已失效',
  'pages.newsBroadcast.shareBrief.keyPoints': '核心要点',
  'pages.newsBroadcast.shareBrief.hiddenSignals': '隐藏信号',
  'pages.newsBroadcast.shareBrief.actionAdvice': '行动建议',
  'pages.newsBroadcast.shareBrief.readingTime': '预计阅读 {minutes} 分钟',
  'pages.newsBroadcast.shareBrief.footer': '内容由 AI 生成，来自「{brand}」',
  'pages.newsBroadcast.dataManagement.title': '数据管理',
  'pages.newsBroadcast.dataManagement.subtitle': '管理联播期次与新闻明细数据',
  'pages.newsBroadcast.admin.title': '管理后台',
  'pages.newsBroadcast.admin.subtitle': '执行采集、分析、清理等管理操作',
  'pages.newsBroadcast.settings.title': '系统设置',
  'pages.newsBroadcast.settings.subtitle': '配置通知、分析与数据源参数',
  'newsBroadcast.dataManagement.broadcastList': '新闻联播列表',
  'newsBroadcast.dataManagement.newsDetail': '新闻详情',
  'newsBroadcast.dataManagement.selectBroadcast': '请选择一条新闻联播',
  'newsBroadcast.dataManagement.noNews': '暂无新闻数据',
  'newsBroadcast.dataManagement.newsCount': '新闻数量',
  'newsBroadcast.dataManagement.lunarDate': '农历',
  'newsBroadcast.dataManagement.solarTerm': '当前节气',
  'newsBroadcast.dataManagement.nextSolarTerm': '下一节气',
  'newsBroadcast.dataManagement.summary': '摘要',
  'newsBroadcast.dataManagement.noSummary': '暂无摘要',
  'newsBroadcast.dataManagement.readCount': '阅读量',
  'newsBroadcast.dataManagement.shareCount': '分享量',
  'newsBroadcast.dataManagement.heatScore': '热度评分',
  'newsBroadcast.dataManagement.keywordAnalysis': '关键词分析',
  'newsBroadcast.dataManagement.contentAnalysis': '内容分析',
  'newsBroadcast.common.refresh': '刷新',
  'newsBroadcast.common.noData': '暂无数据',
  'newsBroadcast.common.error': '操作失败，请稍后重试',
  'newsBroadcast.common.published': '已发布',
  'newsBroadcast.common.draft': '草稿',
  'newsBroadcast.common.archived': '已归档',
  'newsBroadcast.common.view': '查看',
  'newsBroadcast.common.share': '分享',
  'newsBroadcast.common.download': '下载',
  'newsBroadcast.common.keyword': '关键词',
};
